import { defineStore } from 'pinia'

const RETRIES = 3

export const useSocketStore = defineStore({
    id: 'socket',
    state: () => ({
        stompClient: null,
        listeners: new Map(),
        connectionRetriesLeft: RETRIES
    }),
    actions: {
        reset() {
            this.stompClient = null
            this.listeners = new Map(),
            this.connectionRetriesLeft = RETRIES
        },
        resetRetriesCounter() {
            this.connectionRetriesLeft = RETRIES
        }
    }
})